import { Injectable } from '@angular/core';
import { Constants } from '../constants/constants';
import { HttpMiddleLayerService } from './http-middle-layer.service';

@Injectable({
  providedIn: 'root'
})
export class PlatformService {

  constructor(private middleLayer: HttpMiddleLayerService) { }

  getPlatformDetails(){
    const url = Constants.API.url +`platforms`;
    return  this.middleLayer.get(url, null, null, null);
  }

  addPlatformDetails(data){
    const url = Constants.API.url + `platform`;
    return  this.middleLayer.post(url,data,null,null,null);
  }

  updatePlatformDetails(data,id){
    const pathParam = [id];
    const url = Constants.API.url + 'platform/{0}';
    return  this.middleLayer.post(url,data,null,pathParam,null)
  }
}
